const legacyMicroSites = [
  {
    path: '/micro-site/10thAnniversary',
    component: () =>
      import(
        /* webpackChunkName: "microsite-10thAnniversary" */ '@/views/microsites/legacy/10thAnniversary/10thAnniversary'
      ),
    isLegacy: true,
  },
  {
    path: '/micro-site/14thanniversary',
    component: () =>
      import(
        /* webpackChunkName: "microsite-14thAnniversary" */ '@/views/microsites/legacy/14thAnniversary/14thAnniversary'
      ),
    isLegacy: true,
  },
  {
    path: '/micro-site/blackheaven',
    component: () =>
      import(/* webpackChunkName: "microsite-BlackHeaven" */ '@/views/microsites/legacy/BlackHeaven/BlackHeaven'),
    isLegacy: true,
  },
  {
    path: '/micro-site/awake',
    component: () => import(/* webpackChunkName: "microsite-Awake" */ '@/views/microsites/legacy/Awake/Awake'),
    isLegacy: true,
  },
  {
    path: '/micro-site/firepower',
    component: () =>
      import(/* webpackChunkName: "microsite-Firepower" */ '@/views/microsites/legacy/Firepower/Firepower'),
    isLegacy: true,
  },
  {
    path: '/micro-site/returntoadventure',
    component: () =>
      import(
        /* webpackChunkName: "microsite-ReturnToAdventure" */ '@/views/microsites/legacy/Returntoadventure/Returntoadventure'
      ),
    isLegacy: true,
  },
  {
    path: '/micro-site/glory',
    component: () => import(/* webpackChunkName: "microsite-Glory" */ '@/views/microsites/legacy/Glory/Glory'),
    isLegacy: true,
  },
  {
    path: '/micro-site/neo',
    component: () => import(/* webpackChunkName: "microsite-Neo" */ '@/views/microsites/legacy/Neo/Neo'),
    isLegacy: true,
  },
  {
    path: '/micro-site/laraonair',
    component: () =>
      import(/* webpackChunkName: "microsite-Laraonair" */ '@/views/microsites/legacy/Laraonair/Laraonair'),
    isLegacy: true,
  },
  {
    path: '/micro-site/pathfinder',
    component: () =>
      import(/* webpackChunkName: "microsite-Pathfinder" */ '@/views/microsites/legacy/Pathfinder/Pathfinder'),
    isLegacy: true,
  },
  {
    path: '/micro-site/worldsunite',
    component: () =>
      import(/* webpackChunkName: "microsite-Worldsunite" */ '@/views/microsites/legacy/Worldsunite/Worldsunite'),
    isLegacy: true,
  },
  {
    path: '/micro-site/dawnveil',
    component: () => import(/* webpackChunkName: "microsite-Dawnveil" */ '@/views/microsites/legacy/Dawnveil/Dawnveil'),
    isLegacy: true,
  },
  {
    path: '/micro-site/unleashed',
    component: () =>
      import(/* webpackChunkName: "microsite-Unleashed" */ '@/views/microsites/legacy/Unleashed/Unleashed'),
    isLegacy: true,
  },
  {
    path: '/micro-site/red',
    component: () => import(/* webpackChunkName: "microsite-Red" */ '@/views/microsites/legacy/Red/Red'),
    isLegacy: true,
  },
  {
    path: '/micro-site/beasttamer',
    component: () =>
      import(/* webpackChunkName: "microsite-beasttamer" */ '@/views/microsites/legacy/Beasttamer/Beasttamer'),
    isLegacy: true,
  },
  {
    path: '/micro-site/rise/promise',
    component: () => import(/* webpackChunkName: "microsite-Promise" */ '@/views/microsites/legacy/Promise/Promise'),
    isLegacy: true,
  },
  {
    path: '/micro-site/rise/surgeofpower',
    component: () =>
      import(/* webpackChunkName: "microsite-SurgeOfPower" */ '@/views/microsites/legacy/SurgeOfPower/SurgeOfPower'),
    isLegacy: true,
  },
  {
    path: '/micro-site/v-update',
    component: () => import(/* webpackChunkName: "microsite-v-update" */ '@/views/microsites/legacy/v-update/index'),
    name: 'v-update-index',
    isLegacy: true,
    children: [
      {
        name: 'v-update-main',
        path: '',
        component: () =>
          import(/* webpackChunkName: "microsite-v-update" */ '@/views/microsites/legacy/v-update/main-page'),
      },
      {
        path: ':id/:seoLink?',
        name: 'v-update-article',
        component: () =>
          import(/* webpackChunkName: "microsite-v-update" */ '@/views/microsites/legacy/v-update/article'),
      },
      {
        path: 'register',
        name: 'v-update-register',
        component: () =>
          import(/* webpackChunkName: "microsite-v-update" */ '@/views/microsites/legacy/v-update/register'),
      },
    ],
  },
  {
    path: '/micro-site/override',
    component: () => import(/* webpackChunkName: "microsite-override" */ '@/views/microsites/legacy/override/index'),
    name: 'override-index',
    isLegacy: true,
    children: [
      {
        path: '',
        name: 'override-main',
        component: () =>
          import(/* webpackChunkName: "microsite-override" */ '@/views/microsites/legacy/override/main-page'),
      },
      {
        path: ':id/:seoLink?',
        name: 'override-article',
        component: () =>
          import(/* webpackChunkName: "microsite-override" */ '@/views/microsites/legacy/override/article'),
      },
      {
        path: 'register',
        name: 'override-register',
        component: () =>
          import(/* webpackChunkName: "microsite-override" */ '@/views/microsites/legacy/override/register'),
      },
      {
        path: 'journey',
        name: 'override-journey',
        component: () =>
          import(/* webpackChunkName: "microsite-override" */ '@/views/microsites/legacy/override/journey'),
      },
    ],
  },
  {
    path: '/micro-site/nova',
    component: () => import(/* webpackChunkName: "microsite-nova" */ '@/views/microsites/legacy/nova/index'),
    name: 'nova-index',
    isLegacy: true,
    children: [
      {
        path: '',
        name: 'nova-main',
        component: () => import(/* webpackChunkName: "microsite-nova" */ '@/views/microsites/legacy/nova/main-page'),
      },
      {
        path: ':id/:seoLink?',
        name: 'nova-article',
        component: () => import(/* webpackChunkName: "microsite-nova" */ '@/views/microsites/legacy/nova/article'),
      },
      {
        path: 'register',
        name: 'nova-register',
        component: () => import(/* webpackChunkName: "microsite-nova" */ '@/views/microsites/legacy/nova/register'),
      },
      {
        path: 'journey',
        name: 'nova-journey',
        component: () => import(/* webpackChunkName: "microsite-nova" */ '@/views/microsites/legacy/nova/journey'),
      },
      {
        path: 'art',
        name: 'nova-art',
        component: () => import(/* webpackChunkName: "microsite-nova" */ '@/views/microsites/legacy/nova/art'),
      },
    ],
  },
  {
    path: '/micro-site/blackmage',
    component: () => import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/index'),
    name: 'blackmage-index',
    isLegacy: true,
    children: [
      {
        path: '',
        name: 'blackmage-main',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/main-page'),
      },
      {
        path: 'community',
        name: 'blackmage-community',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/community'),
      },
      {
        path: 'mission2',
        name: 'blackmage-mission2',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/mission2'),
      },
      {
        path: 'msmcoupon',
        name: 'blackmage-msmcoupon',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/msmcoupon'),
      },
      {
        path: 'gifts',
        name: 'blackmage-gifts',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/gifts'),
      },
      {
        path: 'mission',
        name: 'blackmage-mission',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/mission'),
      },
      {
        path: 'base',
        name: 'blackmage-base',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/base'),
      },
      {
        path: 'webtoon/:id/:seoLink?',
        name: 'blackmage-webtoon',
        component: () =>
          import(/* webpackChunkName: "microsite-blackmage" */ '@/views/microsites/legacy/blackmage/webtoon-article'),
      },
    ],
  },
  {
    path: '/micro-site/ark',
    component: () => import(/* webpackChunkName: "microsite-ark" */ '@/views/microsites/legacy/ark/index'),
    name: 'ark-index',
    isLegacy: true,
    children: [
      {
        path: ':slide?',
        name: 'ark-slide',
        component: () => import(/* webpackChunkName: "microsite-ark" */ '@/views/microsites/legacy/ark/index'),
      },
      {
        path: 'rewards',
        name: 'ark-rewards',
        component: () => import(/* webpackChunkName: "microsite-ark" */ '@/views/microsites/legacy/ark/rewards'),
      },
    ],
  },
]

export default legacyMicroSites
